const OPEN_AI_BASE_URL = 'https://api.openai.com';

const OPEN_AI_AUTHERIZATION = 'Bearer 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';

const OPEN_AI_VERSION = '/v1';

const OPEN_AI_MODEL = Object.freeze({
  GPT_4: "gpt-4",
  GPT_4O_MINI: "gpt-4o-mini",
  GPT_4O: "gpt-4o",
  GPT_4_TURBO: "gpt-4-turbo"
});

const OPEN_AI_ROUTES = {
  CHAT: `${OPEN_AI_BASE_URL}${OPEN_AI_VERSION}/chat`,
}

const OPEN_AI_ENDPOINTS = {
  CHAT: `${OPEN_AI_ROUTES.CHAT}/completions`,
}


const OPEN_AI_QUERY = Object.freeze({
  QUERY_1: "You are an expert movie trivia generator. Based only on the provided movie metadata, generate as many interesting and unique multiple-choice questions (MCQs) as possible. Return the result as a JSON array, with each item containing a unique question ID, question text, 4 options, the correct answer, and answer ID.",
  QUERY_2: `
    You are an expert movie trivia generator.
    
    Based only on the provided movie metadata (including genres, storyline, production companies, spoken languages, and images like posters, backdrops, and logos), generate as many interesting and unique multiple-choice questions (MCQs) as possible.
    
    Your output should include:
    
    - **Standard trivia**: Based on plot, language, budget, cast, year, etc.
    - **Multimedia-based questions**: Use poster, logo, or backdrop image metadata to ask visual/inference-based questions (e.g., dominant colors, visual elements, languages on poster).
    - Each question must have a **difficulty** level: one of \`"easy"\`, \`"medium"\`, or \`"hard"\`.
    
    Format the result as a **JSON array** of questions. Each item must follow this exact structure:
    
    \`\`\`json
    {
      "id": "<unique-question-id>",
      "question": "<question text>",
      "options": ["A", "B", "C", "D"],
      "correctAnswer": "<exact value of correct option>",
      "correctAnswerIndex": <0–3>,
      "difficulty": "<easy | medium | hard>"
    }
    \`\`\`
    Do not include any explanation or commentary. Just return the array.
    ` ,
  QUERY_3: `
    You are a movie trivia generator.
    
    Based **only** on the provided movie metadata (including genres, synopsis, runtime, production companies, spoken languages, and especially visual assets like posters, backdrops, and logos), generate as many interesting and unique **multiple-choice questions (MCQs)** as possible.
    
    You must include:
    - At least **3 multimedia-based questions**. These can use:
      - Poster visuals (color, language, visual elements, character count, etc.)
      - Logo file names or languages
      - Backdrop scenery or themes (e.g., desert, crowd, sport)
    - General knowledge questions (title, release year, genre, language, etc.)
    - Each question must include a **difficulty**: \`easy\`, \`medium\`, or \`hard\`
    
    ### ✅ Output format must be a strict JSON array, no markdown or comments:
    Each question object must follow this structure:
    {
      "id": "<unique-question-id>",
      "question": "<question text>",
      "options": ["A", "B", "C", "D"],
      "correctAnswer": "<exact value from options>",
      "correctAnswerIndex": <0–3>,
      "difficulty": "<easy | medium | hard>"
    }
    
    Only return the array. Do not add any explanation.
    `,
  QUERY_4: `
    You are a movie trivia generator.
    
    Based on the provided movie metadata (including genres, synopsis, runtime, production companies, spoken languages, and especially visual assets like posters, backdrops, and logos), generate as many interesting and unique **multiple-choice questions (MCQs)** as possible.
    
    You must include:
    - At least **3 multimedia-based questions**. These can use:
      - Poster visuals (color, language, visual elements, character count, etc.)
      - Logo file names or languages
      - Backdrop scenery or themes (e.g., desert, crowd, sport)
    - General knowledge questions (title, release year, genre, language, etc.)
    - Each question must include a **difficulty**: \`easy\`, \`medium\`, or \`hard\`
    
    ### ✅ Output format must be a strict JSON array, no markdown or comments:
    Each question object must follow this structure:
      {
  "questionType": "",
  "questionId": "<unique-question-id>",
  "questionText": "<question text>",
  "status": "<active | in-review>",
  "options": [
    {
      "id": "<unique-option-id>",
      "text": "<option-text>",
      "label": "<A | B | C | D ...>",
      "multimedia": {
        "mediaType": "<option-image/video/audio>",
        "url": "<option-url>",
        "aspectRatio": "<option-media-ratio>"
      }
    }
  ],
  "tags": [
   {
      "type": "difficulty",
      "details": {
        "value": "<easy | medium | hard>",
        "id": ""
      }
    },
  ],
  "answer": {
    "id": "<exact correctAnswer id from options>"
  }
}
    
    Only return the array. Do not add any explanation.
    `,
})

export { OPEN_AI_BASE_URL, OPEN_AI_ROUTES, OPEN_AI_ENDPOINTS, OPEN_AI_MODEL, OPEN_AI_AUTHERIZATION, OPEN_AI_QUERY }